import { Toastr } from 'components/global/Toastr'
import { QuestionairOptions } from 'containers/authorised/ATS/templates/ApplicationFormTemplate/ApplicationFormTemplate'
import { Action } from 'types/redux'
import { handleResponseErr } from 'utils/apiHelperUtils'
import * as actions from './actions'

type TLinksFields = {
  link_value: string
  candidate_link_type_id: number
  text: string
}

export type TScreeningQuestionFields = {
  id: number
  title: string
  screening_question_options_attributes: QuestionairOptions[]
  question_type:
    | 'short_text'
    | 'paragraph'
    | 'attachments'
    | 'checkbox'
    | 'multiple_choice'
    | 'yes_no'
  is_required: boolean
  position: number
}

export type TCareer =
  | 'name_en'
  | 'name_ar'
  | 'phone_number'
  | 'nationality'
  | 'current_role'
  | 'city'
  | 'country'
  | 'address'
  | 'cv_file'
  | 'email'

export type Career = {
  job_details: {
    id: number
    title: string
    description: string
    company_about_infos: string
    organization_id: number
    organization_name: string
    department: string
    location: string
    employment_type: string
    status: 'open' | 'closed'
    organization_logo: string
  }
  job_form_details: {
    candidate_profile_fields: {
      name_en?: boolean
      name_ar?: boolean
      phone_number?: boolean
      current_role?: boolean
      email?: boolean
      address?: boolean
      city?: boolean
      country_id?: boolean
      nationality_id?: boolean
      cv_file?: boolean
      links?: boolean
    }
    locale: 'en' | 'ar'
    screening_questions: TScreeningQuestionFields[]
    candidate_link_types: TLinksFields[]
  }
}

type TData =
  | {
      id: number
      name_en: string
      name_ar: string
      name_i18n: string
    }
  | undefined

export type TCandidateInfos = {
  nationality: TData[]
  country: TData[]
}
export type TStatusApi = 'idle' | 'loading' | 'success' | 'failed'

type InitialStateType = {
  status: TStatusApi
  fetching: boolean
  apply_loading: boolean
  career: Career
  candidateInfos: TCandidateInfos
  errorMsg: string
  sumitionState: boolean
}

const initialState: InitialStateType = {
  sumitionState: false,
  status: 'idle',
  fetching: false,
  apply_loading: false,
  errorMsg: '',
  candidateInfos: {
    nationality: [],
    country: [],
  },
  career: {
    job_form_details: {
      candidate_profile_fields: {},
      locale: 'en',
      screening_questions: [],
      candidate_link_types: [],
    },
    job_details: {
      id: 0,
      title: '',
      description: '',
      organization_id: 0,
      organization_name: '',
      department: '',
      location: '',
      employment_type: '',
      status: 'closed',
      company_about_infos: '',
      organization_logo: '',
    },
  },
}

export default function reducer(state = initialState, action: Action): InitialStateType {
  switch (action.type) {
    case actions.GET_CAREER_PENDING: {
      return {
        ...state,
        status: 'loading',
        fetching: true,
      }
    }
    case actions.CANDIDATE_INFOS_PENDING: {
      return {
        ...state,
        fetching: true,
      }
    }

    case actions.APPLY_CAREER_PENDING: {
      return {
        ...state,
        apply_loading: true,
      }
    }

    case actions.CANDIDATE_INFOS_FULFILLED: {
      return {
        ...state,
        candidateInfos: action?.payload.data.data,
        fetching: false,
      }
    }

    case actions.GET_CAREER_FULFILLED: {
      return {
        ...state,
        status: 'success',
        career: action?.payload.data.data,
        fetching: false,
      }
    }
    case actions.APPLY_CAREER_FULFILLED: {
      return {
        ...state,
        sumitionState: true,
        apply_loading: false,
      }
    }

    case actions.APPLY_CAREER_REJECTED:
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        errorMsg: handleResponseErr(action.payload),
        apply_loading: false,
      }

    case actions.GET_CAREER_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        status: 'failed',
        fetching: false,
      }
    }

    case actions.CANDIDATE_INFOS_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching: false,
      }
    }
    default:
      return state
  }
}
